import { Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { AnalyticsService } from '@dxo/ng-swift-ui';

@Injectable({
  providedIn: 'root'
})
export class TimePerPageService {
  constructor(private eventTrackingService: AnalyticsService) {}

  public lastPage: string | undefined;
  private lastNavigationTime = 0;

  onPageChange(event: NavigationEnd) {
    const currentPage = this.getPage(event);

    if (this.lastPage && currentPage !== this.lastPage) {
      const timeOnPage: number = new Date().getTime() - this.lastNavigationTime;
      this.eventTrackingService.trackEvent({
        label: 'TimeOnPage',
        category: 'Navigation',
        action: this.lastPage,
        value: timeOnPage
      });
    }

    this.lastNavigationTime = new Date().getTime();
    this.lastPage = currentPage;
  }

  private getPage(event: NavigationEnd): string {
    return event.url.split('?')[0];
  }
}
